import axios from "axios"
// import Vue from "vue"
import md5 from "md5"
// import store from "../store"
// import router from "../router"
import BsMessage from "../components/packages/message/index"
// import stateStatus from "../assets/js/statestatus"
// import apiApp from "../utils/callApp"
import appApi from "../utils/appApi"
// 创建实例
// let vue = new Vue()

// 接口地址
// const baseURL = process.env.VUE_APP_API
const baseURL = CABAPI_URL

// 创建axios实例
const service = axios.create({
    baseURL: baseURL, // url = base url + request url
    timeout: 1000 * 60, // 请求超时时间
    withCredentials: false, //send cookies when cross-domain requests
})

// request拦截器
service.interceptors.request.use(config => {
    const ts = new Date().getTime()
    let token = ""
    const proTokenUrls = ["",]
    const isProTokenUrl = proTokenUrls.includes(config.url)
    if (isProTokenUrl) {
        token = md5("BLUE" + ts + "SHARK")        
    } else {
        token=localStorage.getItem('token')
    }
    config.headers["Authorization"] = "Bearer " + token
    // if(process.env.NODE_ENV=='development'){
    //     config.headers["Authorization"] = "Bearer " + 'token2268815006c019c40aba842dfd97792a'
    // }else{
    //     config.headers["Authorization"] = "Bearer " + token
    // }
    config.headers["ts"] = ts
    config.headers["SGAGENT"]=PKG_NAME

    return config
}, error => {
    return Promise.reject(error)
})

// 拦截响应
service.interceptors.response.use(res => {
    if (res.status == 200) {
        if (res.data.state == 0) {
            return res.data
        } else {
            // 错误统一由app统一处理
            appApi.checkError(res.data.state,res.data.state_info)
            return Promise.reject(res.data)
        }
    } else {
        return Promise.reject(res.data)
    }
}, error => {
    const reg=/timeout of/
    if(reg.test(error.message)){
        BsMessage({message:"timeout of 60s exceeded",type:"warning"})
    }else{
        BsMessage({message:error.message,type:"warning"})
    }
    return Promise.reject(error)
})

const request = (url, method, data) => {

    return service.request({
        url,
        method,
        data
    })
}
export default {
    service,
    request,
}


// WEBPACK FOOTER //
// ./src/axios/request.js